import { render, staticRenderFns } from "./StudioForm.vue?vue&type=template&id=62e6186a&scoped=true&"
import script from "./StudioForm.vue?vue&type=script&lang=js&"
export * from "./StudioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e6186a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e6186a')) {
      api.createRecord('62e6186a', component.options)
    } else {
      api.reload('62e6186a', component.options)
    }
    module.hot.accept("./StudioForm.vue?vue&type=template&id=62e6186a&scoped=true&", function () {
      api.rerender('62e6186a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/studios/components/StudioForm.vue"
export default component.exports